import React, { useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../Loading/LoadingOverlay';
import { isExplicitlyLoggedOut } from '../../utils/authSession';
import {
  consumePostAuthRedirect,
  DEFAULT_AUTH_REDIRECT,
  readPostAuthRedirect,
} from '../../utils/authRedirect';
import { readPendingInvite } from '../../utils/pendingInvites';

export default function PublicOnly({ children, restoreRequestedRoute = false }) {
  const { data: user, loading, bootstrapped } = useSelector((state) => state.user);
  const location = useLocation();
  const redirectRef = useRef(null);

  if (!bootstrapped || loading) return <LoadingOverlay />;

  if (user && !isExplicitlyLoggedOut()) {
    if (!redirectRef.current) {
      const hasPendingInvite = Boolean(readPendingInvite());
      redirectRef.current = restoreRequestedRoute
        ? hasPendingInvite
          ? readPostAuthRedirect() || DEFAULT_AUTH_REDIRECT
          : consumePostAuthRedirect(location.state?.from)
        : DEFAULT_AUTH_REDIRECT;
    }
    return <Navigate to={redirectRef.current} replace />;
  }

  return children;
}
